import { modelsCompFn } from '@/lib/filter/base-frontend-filter/scope';
import { propertyType } from 'shared/constants.json';

export const lookupFn = ({ propertyValues, scope, lookupPropertySvc }) => {
  if (lookupPropertySvc === undefined) {
    return false;
  }

  let models = [];
  let neededModels = [];
  switch (scope.property.lookupProperty.type) {
    case propertyType.user:
      models = lookupPropertySvc.getSelectedUsers(propertyValues, scope.property);
      neededModels = scope.users;
      break;
    case propertyType.space:
      models = lookupPropertySvc.getSpaces(propertyValues, scope.property);
      neededModels = scope.spaces;
      break;
    case propertyType.singleSelect:
    case propertyType.options:
      models = lookupPropertySvc.getSelectedOptions(propertyValues, scope.property);
      neededModels = scope.selectedOptions;
      break;
    default:
      return true;
  }
  return modelsCompFn({ models, neededModels, isEmpty: scope.isEmpty });
};
